export default "__VITE_ASSET__b00a03a4__"